exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container---2A5Br {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  height: 100%;\n  min-height: 30px;\n  background: #dbeeed; }\n\n.label---2d819 {\n  width: 84%;\n  padding-left: 10px;\n  float: left;\n  color: #444;\n  font-family: Poppins, sans-serif;\n  font-size: 13px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.svgIconContainer---3WEvE {\n  width: 17px;\n  height: 17px;\n  padding-top: 5px; }\n\n.svgIconContainer---3WEvE svg path {\n    fill: white !important; }\n\n.buttonWrapper---1m2VR {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  -moz-justify-content: center;\n  justify-content: center;\n  float: right;\n  width: 15%; }\n\n.button---3gv5L, .view---3j8fP, .cancel---2DYgx {\n  height: 30px;\n  width: 30px;\n  border-radius: 30px; }\n\n.spacing---14X0P {\n  padding: 3px; }\n\n.view---3j8fP {\n  background: #1c7fc3; }\n\n.cancel---2DYgx {\n  background: #a3c1c0; }\n", ""]);

// exports
exports.locals = {
	"container": "container---2A5Br",
	"label": "label---2d819",
	"svgIconContainer": "svgIconContainer---3WEvE",
	"buttonWrapper": "buttonWrapper---1m2VR",
	"button": "button---3gv5L",
	"view": "view---3j8fP",
	"cancel": "cancel---2DYgx",
	"spacing": "spacing---14X0P"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/new-course-label/index.scss
// module id = 1140
// module chunks = 3